import React, { Component, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Slider from "@material-ui/core/Slider";
import Box from "@material-ui/core/Box";

import {
	withStyles
} from "@material-ui/core";

import { slider as styles } from "./styles";

function SliderFilter({ classes, min, max, name, onChange, defaultValue }) {
	function valuetext(value) {
		if (value === 6) {
			return "tous";
		}
		if (value === 1){
			return "1 à 3"
		}
		return `R + ${value}`;
	}

	function preventHorizontalKeyboardNavigation(event) {
		if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
			event.preventDefault();
		}
	}

	const marks = [
		{
			value: 0,
			label: valuetext(0)
		},{
			value: 1,
			label: valuetext(1)
		},{
			value: 2,
			label: valuetext(4)
		},{
			value: 3,
			label: valuetext(5)
		},
		{
			value: 4,
			label: valuetext(6)
		}
	];

	return (
		<Slider
			classes={{
				vertical: classes.customVertical,
				root: classes.customRoot,
				thumb: classes.customThumb,
				track: classes.customTrack,
				rail: classes.customRail,
				mark: classes.customMarks,
				markLabel: classes.customLabel
			}}

			defaultValue={defaultValue}
			name={name}
			//  valueLabelDisplay="auto"
			// getAriaValueText={valuetext}
			// valueLabelFormat={valuetext}
			marks={marks}
			min={min}
			max={max}
			step={null}
			onChange={onChange}
			orientation={"vertical"}
			onKeyDown={preventHorizontalKeyboardNavigation}
		/>
	);
}

SliderFilter.propTypes = {
	classes: PropTypes.object.isRequired,
	max: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(SliderFilter);
